/**
 * Dashboard views — add new entries here to extend the owner dashboard.
 */
export const DASHBOARD_VIEWS = [
  {
    id: "overview",
    label: "Overview",
    description: "Business health at a glance from your live schedule and website.",
    source: null,
  },
  {
    id: "enrollment",
    label: "Enrollment",
    description: "Capacity, waitlists, and scheduling recommendations from Jackrabbit.",
    source: "Jackrabbit",
  },
  {
    id: "analytics",
    label: "Website analytics",
    shortLabel: "Analytics",
    description: "Program interest, register clicks, and class finder usage from your site.",
    source: "Google Analytics",
  },
  {
    id: "meet-analytics",
    label: "Bourbon City Spectacular",
    shortLabel: "Meet",
    description:
      "Meet page visits, register clicks, section engagement, and FAQ activity — separate from class registration.",
    source: "Google Analytics",
  },
];

export const getDashboardView = (viewId) =>
  DASHBOARD_VIEWS.find((view) => view.id === viewId) || DASHBOARD_VIEWS[0];

export const GA4_DASHBOARD_VIEWS = ["analytics", "meet-analytics"];

export const isValidDashboardView = (viewId) =>
  DASHBOARD_VIEWS.some((view) => view.id === viewId);
